import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { IMonthValue } from '../../util/DateUtils';

export interface ITransportSummaryReportRow {
  name: string;
  km: number;
  eur: number;
  eurPct: number;
}

export interface ITransportSummaryReportProps {
  startDate: IMonthValue;
  endDate: IMonthValue;
  data: ITransportSummaryReportRow[];
}

const COLUMNS = [
  'name',
  'km',
  'eur',
  'eurpct'
];

const SORTABLE_COLUMNS = [
  'name',
  'km',
  'eur',
  'eurpct'
];

const TransportSummaryReport: React.FunctionComponent<ITransportSummaryReportProps> = (props: ITransportSummaryReportProps) => {
  const [dataTable] = useState(props.data);
  const [orderColumn, setOrderColumn] = useState('');
  const [orderDirection, setOrderDirection] = useState(1); // 1 | -1

  const setOrdering = (column: string) => {
    if (orderColumn !== column) {
      setOrderColumn(column);
      setOrderDirection(1);
    } else {
      setOrderDirection(-orderDirection);
    }
  }

  const getTableHeaders = () => {
    const headers: JSX.Element[] = [];
    COLUMNS.forEach((name) => {
      const classes = ['header'];
      let icon = null;
      let sortable = false;
      if (SORTABLE_COLUMNS.includes(name)) {
        classes.push('sortable');
        sortable = true;
      }
      if (name === orderColumn) {
        classes.push('sortby');
        icon = orderDirection === 1 ?
          <FontAwesomeIcon className="icon" icon="sort-up" color="white" /> : <FontAwesomeIcon className="icon" icon="sort-down" color="white" />
      } else if (sortable) {
        icon = <FontAwesomeIcon className="icon" icon="sort" color="lightgray" />
      }
      headers.push(
        <th key={name}>
          <span className={classes.join(' ')} onClick={() => sortable && setOrdering(name)}>
          <FormattedMessage id={`sortsummaryreports.browse.datatable.${name}`}/> {icon}
        </span></th>
      );
    })
    return headers;
  }

  const comparer = (a: ITransportSummaryReportRow, b: ITransportSummaryReportRow) => {
    let value = 0;
    if (orderColumn !== '') {
      switch(orderColumn) {
        case 'name':
          value = a.name.localeCompare(b.name);
          break;
        case 'km':
          value = a.km - b.km;
          break;
        case 'eur':
          value = a.eur - b.eur;
          break;
        case 'eurpct':
          value = a.eurPct - b.eurPct;
      }
    }
    return orderDirection * value;
  }

  const getDataTable = () => {
    const options: { }[] = [];
    if (dataTable && Array.isArray(dataTable)) {
      dataTable.sort(comparer).forEach((row : ITransportSummaryReportRow, index) => {
        options.push(
          <tr key={index}>
            <td><FormattedMessage id={`sortsummaryreports.browse.datatable.${row.name}`}/></td>
            <td className="right"><FormattedNumber value={row.km} maximumFractionDigits={2} minimumFractionDigits={2}/></td>
            <td className="right"><FormattedNumber value={row.eur} maximumFractionDigits={2} minimumFractionDigits={2}/></td>
            <td className="right"><FormattedNumber value={row.eurPct} maximumFractionDigits={2} minimumFractionDigits={2}/></td>
          </tr>
        );
      });
    }
    return options;
  }

  return (
    <div className="sortReportImportResult generalReportImportResult">
      <div className="d-flex flex-md-row flex-column-reverse">
        <div className="reportResultHeader">
          <h3 className="monthRange">
              <FormattedDate
                  value={new Date(props.startDate.year, props.startDate.month)}
                  month="long"
                  year="numeric"
                /> -<br/>
              <FormattedDate
                  value={new Date(props.endDate.year, props.endDate.month)}
                  month="long"
                  year="numeric"
                />
            </h3>
            <h3 className="reportHeader">
              <FormattedMessage id="transportsummaryreports.import.handlingreport"/>
            </h3>
        </div>
        <div className="handlerNameHeader text-right ml-md-auto">
            <h1 className="float-right"><FormattedMessage id="transportsummaryreports.import.header"/></h1>
        </div>
      </div>

      <div className="checkSum table-responsive ">
        <Table className="table table-sm table-striped">
          <thead className="reportDataHeader table table-bordered table-sm">
            <tr>
              { getTableHeaders() }
            </tr>
          </thead>
          <tbody className="reportData table table-bordered">
            { getDataTable() }
          </tbody>
        </Table>
      </div>

    </div>
  )
}

export default TransportSummaryReport;
